export const training = {
  methods: {
    //TODO：获取全部类型
    async getLevel() {
      let res = await this.$http.get("/course/topic/type/tree/list");

      return res;
    },
    //TODO： 新增类型
    async addType(obj) {
      let res = await this.$http.post("/course/topic/type", obj);
      if (res.code == 200) {
        this.$message({ message: res.msg, type: "success" });
      } else {
        this.$message.error(res.msg);
      }
      return res;
    },
    //TODO： 修改类型
    async upType(obj) {
      let res = await this.$http.put("/course/topic/type", obj);
      if (res.code == 200) {
        this.$message({ message: res.msg, type: "success" });
      } else {
        this.$message.error(res.msg);
      }
      return res;
    },
    //TODO： 删除类型
    async delType(id) {
      let res = await this.$http.delete(`/course/topic/type/${id}`);
      if (res.code == 200) {
        this.$message({ message: res.msg, type: "success" });
      } else {
        this.$message.error(res.msg);
      }
      return res;
    },
    //TODO：点击树形查询题目
    async getQuestion(params) {
      let { pageNum, pageSize, topicTypeId } = params;
      let res = await this.$http.get("/course/topic/list", {
        topicTypeId: topicTypeId ?? 0,
        pageNum,
        pageSize,
      });
      return res;
    },

    //TODO: 新增题目
    async addCourseQuestion(obj) {
      let res = await this.$http.post("/course/topic", obj);
      if (res.code == 200) {
        this.$message({ message: res.msg, type: "success" });
      } else {
        this.$message.error(res.msg);
      }
      return res;
    },
    //TODO: 修改题目
    async upCourseQuestion(obj) {
      let res = await this.$http.put("/course/topic", obj);
      if (res.code == 200) {
        this.$message({ message: res.msg, type: "success" });
      } else {
        this.$message.error(res.msg);
      }
      return res;
    },
    //TODO： 删除题目
    async delCourseQuestion(id) {
      let res = await this.$http.delete(`/course/topic/${id}`);
      if (res.code == 200) {
        this.$message({ message: res.msg, type: "success" });
      } else {
        this.$message.error(res.msg);
      }
      return res;
    },

    //TODO: 获取学习分类
    async getStudyType(obj) {
      if (obj) {
        let { pageNum, pageSize, name } = obj;
        let res = await this.$http.get("/course/study/type/list", {
          name: name ?? null,
          pageNum: pageNum ?? null,
          pageSize: pageSize ?? null,
        });
        return res;
      } else {
        let res = await this.$http.get("/course/study/type/list");
        return res;
      }
    },

    //TODO： 新增学习分类
    async addStudyType(obj) {
      let res = await this.$http.post("/course/study/type", obj);
      if (res.code == 200) {
        this.$message({ message: res.msg, type: "success" });
      } else {
        this.$message.error(res.msg);
      }
      return res;
    },
    //TODO： 修改学习分类
    async upStudyType(obj) {
      let res = await this.$http.put("/course/study/type", obj);
      if (res.code == 200) {
        this.$message({ message: res.msg, type: "success" });
      } else {
        this.$message.error(res.msg);
      }
      return res;
    },
    //TODO： 删除学习分类
    async delStudyQuestion(id) {
      let res = await this.$http.delete(`/course/study/type/${id}`);
      if (res.code == 200) {
        this.$message({ message: res.msg, type: "success" });
      } else {
        this.$message.error(res.msg);
      }
      return res;
    },

    //TODO: 获取试卷
    async getPaper(obj) {
      console.log(obj,"55");
      
      let { pageNum, pageSize, name } = obj;
      let res = await this.$http.get("/course/paper/list", {
        name: name ?? null,
        pageNum,
        pageSize,
      });
      return res;
    },
    //TODO： 获取全部试卷
    async getPaperAll() {
      let res = await this.$http.get(`/course/paper/all/list`);
      return res.data;
    },
    //TODO: 获取试卷详细
    async getPaperInfo(id) {
      let res = await this.$http.get(`/course/paper/${id}`);
      return res.data;
    },

    //TODO： 新增试卷
    async addPaper(obj) {
      let res = await this.$http.post("/course/paper", obj);
      if (res.code == 200) {
        this.$message({ message: res.msg, type: "success" });
      } else {
        this.$message.error(res.msg);
      }
      return res;
    },
    //TODO： 修改试卷
    async upPaper(obj) {
      let res = await this.$http.put("/course/paper", obj);
      if (res.code == 200) {
        this.$message({ message: res.msg, type: "success" });
      } else {
        this.$message.error(res.msg);
      }
      return res;
    },
    //TODO： 删除试卷
    async delPaper(id) {
      let res = await this.$http.delete(`/course/paper/${id}`);
      if (res.code == 200) {
        this.$message({ message: res.msg, type: "success" });
      } else {
        this.$message.error(res.msg);
      }
      return res;
    },
    //TODO：获取视频文件/图片/课件
    async getFiles(obj) {
      let { pageNum, pageSize, fileName, studyTypeId, type } = obj;
      let res = await this.$http.get("/course/file/list", {
        type: type ?? null,
        studyTypeId: studyTypeId == "0" ? null : studyTypeId,
        fileName: fileName ?? null,
        pageNum: pageNum ?? null,
        pageSize: pageSize ?? null,
      });
      return res;
    },

    //TODO: 检测文件是否上传
    async uploadCheckAxios(fileMd5) {
      let res = await this.$http.post(`/course/video/check/file`, {
        fileMd5: fileMd5,
      });
      return res;
    },

    //TODO: 分片上传
    async uploadVideoChunkAxios(fetchForm) {
      let res = await this.$http.post(`/course/video/upload/chunk`, fetchForm, {
        "Content-Type": "multipart/form-data",
      });
      return res;
    },
    //TODO: 文件合并
    async mergeFileAxios(obj) {
      let res = await this.$http.post(`/course/video/merge/chunks`, obj);
      return res;
    },

    //TODO: 删除视频
    async delFiles(id) {
      let res = await this.$http.delete(`/course/file/${id}`);
      if (res.code == 200) {
        this.$message({ message: res.msg, type: "success" });
      } else {
        this.$message.error(res.msg);
      }
      return res;
    },
    //TODO:修改视频信息
    async upfileName(obj) {
      let res = await this.$http.put("/course/file", obj);
      if (res.code == 200) {
        this.$message({ message: res.msg, type: "success" });
      } else {
        this.$message.error(res.msg);
      }
      return res;
    },
    //TODO:上传图片
    async addImage(fetchForm) {
      let res = await this.$http.post("/course/video/upload/file", fetchForm, {
        "Content-Type": "multipart/form-data",
      });
      return res;
    },
    //TODO: 获取课程
    async getCentre(obj) {
      let { pageNum, pageSize, name } = obj;
      let res = await this.$http.get("/course/info/list", {
        name: name ?? null,
        pageNum: pageNum ?? null,
        pageSize: pageSize ?? null,
      });
      return res;
    },
    //TODO: 新增课程
    async addCentre(obj) {
      let res = await this.$http.post("/course/info", obj);
      if (res.code == 200) {
        this.$message({ message: res.msg, type: "success" });
      } else {
        this.$message.error(res.msg);
      }
      return res;
    },
    //TODO:修改课程
    async upCentre(obj) {
      let res = await this.$http.put("/course/info", obj);
      if (res.code == 200) {
        this.$message({ message: res.msg, type: "success" });
      } else {
        this.$message.error(res.msg);
      }
      return res;
    },
    //TODO:删除课程
    async delCentre(id) {
      let res = await this.$http.delete(`/course/info/${id}`);
      if (res.code == 200) {
        this.$message({ message: res.msg, type: "success" });
      } else {
        this.$message.error(res.msg);
      }
      return res;
    },
    //TODO： 获取课程详细
    async getCentreInfo(id) {
      let res = await this.$http.get(`/course/info/${id}`);
      return res.data;
    },

    //TODO: 新增课程
    async sendPublish(obj) {
      let res = await this.$http.post("/course/info/publish", obj);
      if (res.code == 200) {
        this.$message({ message: res.msg, type: "success" });
      } else {
        this.$message.error(res.msg);
      }
      return res;
    },

    //TODO：获取已经发布的课程

    //TODO： 获取全部学习记录
    async getStudyRecord(obj) {
      let { pageNum, pageSize, name, userName } = obj;
      let res = await this.$http.get("/course/history/list", {
        userName: userName ?? null,
        name: name ?? null,
        pageNum: pageNum ?? null,
        pageSize: pageSize ?? null,
      });
      return res;
    },

    //TODO: 获取学习记录详细
    async getStudyRecordInfo(id) {
      let res = await this.$http.get(`/course/history/${id}`);
      return res.data;
    },

    //TODO： 新增学习记录（去除）
    async addStudyRecord(obj) {
      let res = await this.$http.post("/course/history", obj);
      if (res.code == 200) {
        this.$message({ message: res.msg, type: "success" });
      } else {
        this.$message.error(res.msg);
      }
      return res;
    },
    //TODO： 修改学习记录
    async upStudyRecord(obj) {
      let res = await this.$http.put("/course/history/set/studyDuration", obj);
      if (res.code == 200) {
        this.$message({ message: res.msg, type: "success" });
      } else {
        this.$message.error(res.msg);
      }
      return res;
    },
    //TODO： 删除学习记录
    async delStudyRecord(id) {
      let res = await this.$http.delete(`/course/history/${id}`);
      if (res.code == 200) {
        this.$message({ message: res.msg, type: "success" });
      } else {
        this.$message.error(res.msg);
      }
      return res;
    },

    //TODO： 获取全部考试记录
    async getStudyNotes(obj) {
      let { pageNum, pageSize, name, userName } = obj;
      let res = await this.$http.get("/course/person/test/history/list", {
        userName: userName ?? null,
        name: name ?? null,
        pageNum: pageNum ?? null,
        pageSize: pageSize ?? null,
      });
      return res;
    },
    //TODO: 获取考试记录详细
    async getStudyNotesInfo(id) {
      let res = await this.$http.get(`/course/person/test/history/${id}`);
      return res.data;
    },
    //TODO： 修改考试记录（去除）
    async upStudyNotes(obj) {
      let res = await this.$http.put("/course/person/test/history", obj);
      if (res.code == 200) {
        this.$message({ message: res.msg, type: "success" });
      } else {
        this.$message.error(res.msg);
      }
      return res;
    },
    //TODO： 删除考试记录
    async delStudyNotes(id) {
      let res = await this.$http.delete(`/course/person/test/history/{${id}`);
      if (res.code == 200) {
        this.$message({ message: res.msg, type: "success" });
      } else {
        this.$message.error(res.msg);
      }
      return res;
    },

    //TODO： 获取我的课程
    async getMyCourse(obj) {
      let { pageNum, pageSize, name } = obj;
      let res = await this.$http.get("/course/info/person/list", {
        name: name ?? null,
        pageNum: pageNum ?? null,
        pageSize: pageSize ?? null,
      });
      return res;
    },

    //TODO: 获取我的课程详细
    async getMyCourseInfo(id) {
      let res = await this.$http.get(`/course/info/person`, {
        studyHistoryId: id,
      });
      return res.data;
    },

    //TODO： 获取培训记录
    async getRecords(obj) {
      let { pageNum, pageSize, meetingTitle ,meetingPeopleName,timeArr } = obj;
      let res = await this.$http.get("/course/train/record/list", {
        meetingTitle: meetingTitle ?? null,
        meetingPeopleName:meetingPeopleName ?? null,
        meetingTime: ( timeArr!= null && timeArr.length >0 ) ? timeArr[0] : '',
        meetingEndTime: ( timeArr!= null && timeArr.length >0 ) ? timeArr[1] : '',
        pageNum: pageNum ?? null,
        pageSize: pageSize ?? null,
      });
      return res;
    },

    //TODO：获取证件信息列表
    async getCertificate(obj) {
      let { pageNum, pageSize, certifiesId } = obj;
      let res = await this.$http.get("/tenant/certifies/list", {
        certifiesId: certifiesId ?? null,
        pageNum: pageNum ?? null,
        pageSize: pageSize ?? null,
      });
      return res;
    },
    //TODO: 获取证件信息详细
    async getCertificateInfo(id) {
      let res = await this.$http.get(`/tenant/certifies/${id}`);
      return res.data;
    },
    //TODO： 新增证件信息
    async addCertificate(obj) {
      let res = await this.$http.post("/tenant/certifies", obj);
      if (res.code == 200) {
        this.$message({ message: res.msg, type: "success" });
      } else {
        this.$message.error(res.msg);
      }
      return res;
    },
    //TODO： 修改证件信息
    async upCertificate(obj) {
      let res = await this.$http.put("/tenant/certifies", obj);
      if (res.code == 200) {
        this.$message({ message: res.msg, type: "success" });
      } else {
        this.$message.error(res.msg);
      }
      return res;
    },
    //TODO： 删除证件信息
    async delCertificate(id) {
      let res = await this.$http.delete(`/tenant/certifies/${id}`);
      if (res.code == 200) {
        this.$message({ message: res.msg, type: "success" });
      } else {
        this.$message.error(res.msg);
      }
      return res;
    },
  },
};
